import { Injectable } from "@nestjs/common";
import { ImageUploadModel } from "./ina.controller";
import * as fs from "fs";

@Injectable()
export class InaImageService {
    constructor() {

    }

    async saveFiles(req: ImageUploadModel, files: any[]) {
        console.log('----------------------------------------');
        console.log(req);
        // save the file in the buffer to the folder
        

        // save the main table record .save();
        // get the saved main record PK

        // QUALITY LOOP {

            // assign the PK of main to every quality
            // save the quality specific record .save();
            // get the saved primary key
            // then save the file names here

            let qualityNumber = 2;
            for(const file of files) {
                console.log(file.originalname);
                // continue;
                if(file?.originalname?.includes('Q'+qualityNumber+'@')) {
                    console.log('Q2 FILE is contained');
                    console.log(file.originalname);

                    const time = Date.now();
                    let fileName = 'FILE-'+time;
                    const buffer = file.buffer;
                    const filePath = 'uploads/fabric/';
                    const outputFileName = filePath+fileName+'.jpg';
                    fs.createWriteStream(outputFileName).write(buffer);

                    
                    // update the path and file name in the db based on the quality key
                }
            }


        // }

    }
}